import { render, staticRenderFns } from "./privace.vue?vue&type=template&id=2772b7f3&scoped=true&"
var script = {}
import style0 from "./privace.vue?vue&type=style&index=0&id=2772b7f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2772b7f3",
  null
  
)

export default component.exports